import React from "react";
import "./switch.css";

const Switch = ({ isOn, handleToggle, onColor, lMessage, rMessage }) => {
  return (
    <label style={{ background: isOn && onColor }} className="react-switch">
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        type="checkbox"
      />
      <div className="react-switch-button" />
      <div className="react-switch-labels">
        <span><b>{lMessage}</b></span>
        <span><b>{rMessage}</b></span>
      </div>
    </label>
  );
};

export default Switch;
